import { Injectable } from '@angular/core';

import { Book } from '../model/book.model';

const BOOKS = [{"_id":1,"title":"The Picture of Dorian Gray","author":"Oscar Wilde","year":1890,"country":"Great Britain","borrower":"Maria Lane"},{"_id":2,"title":"Dopler","author":"Erlend Loe","year":2004,"country":"Norway","borrower":"Anita Smith"},{"_id":3,"title":"Naive. Super","author":"Erlend Loe","year":2006,"country":"Norway","borrower":" John Doe"},{"_id":4,"title":"Magic Belgrade","author":"Momo Kapor","year":2008,"country":"Serbia","borrower":"Will Rige"},{"_id":5,"title":"A man called Ove","author":"Fredrik Backman","year":2014,"country":"Sweden","borrower":"Atria Mao"},{"_id":6,"title":"Island","author":"Mesa Selimovic","year":1974,"country":"Serbia","borrower":"Mia Golding"},{"_id":7,"title":"Fortress","author":"Mesa Selimovic","year":1970,"country":"Serbia","borrower":"Lorem Ipsum"},{"_id":8,"title":"The Hitchhiker's Guide to the Galaxy","author":"Douglas Adams","year":1981,"country":"Great Britain","borrower":"Joao Deno"},{"_id":9,"title":"Summerhill","author":"A.S.Neill","year":1960,"country":"Great Britain","borrower":"Hart Willing"},{"_id":10,"title":"Anna Karenina","author":"Leo Tolstoy","year":1878,"country":"Russia","borrower":"Sergey Stamin"}];


@Injectable({
  providedIn: 'root'
})
export class BookService {
  private bookList :Book[] = [];
	private lastId = 10;

	constructor() { 
		for(let bookObj of BOOKS){
			this.bookList.push(new Book(bookObj)); 
		}
	}

	getAll() :Book[]{
  		return this.bookList;
  	}

  	get(id :number) :Book{
  		let book = this.bookList.find(book => book._id == id);
  		return book;
  	}

  	add(newBook :Book) :void{
  		this.lastId += 1;
      newBook._id = this.lastId;
      this.bookList.push(newBook);
  	}

  	remove(id :number) :void{
  		var index = this.bookList.findIndex(book => book._id == id);
		  if (index > -1) {
   			this.bookList.splice(index, 1);
		  }
  	}

    update(editedBook :Book) :void{
      var index = this.bookList.findIndex(book => book._id == editedBook._id);
      this.bookList[index] = editedBook;
    }
}